// extracted by mini-css-extract-plugin
module.exports = {"stepCard":"Step_stepCard__3BpQ4","stepIcon":"Step_stepIcon__XafVd","stepTitle":"Step_stepTitle__1Khey","bold":"Step_bold__12zNx"};